import { UIHeading5, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './PageService.css';

interface IPageServiceProps {
  title: string;
  url: string;
  image: string;
  description: string;
  onClick(event: React.MouseEvent<HTMLAnchorElement>): void;
}

export const PageService: React.FC<IPageServiceProps> = ({ title, url, image, description, onClick }) => {
  return (
    <a className={styles['container']} href={url} onClick={onClick}>
      <img src={image} alt={title} />
      <div className={styles['text-block']}>
        <UIHeading5>{title}</UIHeading5>
        {description && <UIText2 color="text-secondary-default">{description}</UIText2>}
      </div>
    </a>
  );
};
